module.exports = __webpack_public_path__ + "static/img/image-locked.402ff99e.png";